// extracted by mini-css-extract-plugin
export default {"offerPayment":"OfferPaymentPage_offerPayment__AmMHB","button":"OfferPaymentPage_button__y2zqt"};